<template>
    <div class="header" :class="{ 'no-bg': !useBackground }" :style="styleVars">
        <p>欢迎来到{{ title }}考试报名系统</p>
        <div class="right_title">
            <p>{{ currentWeekday }}</p>
            <p>{{ currentDate }}</p>
            <p>{{ greetingText }}，{{ currentUsername || '游客' }}</p>
        </div>
    </div>
</template>
<script>
import http from '../api/http';
import { getUser } from '../api/storage';
export default {
    name: 'Mytitle',
    props: { useBackground: { type: Boolean, default: true }, textColor: { type: String, default: 'white' }, padding: { type: String, default: '' } },
    data() {
        return {
            title: '',
            currentWeekday: '',
            currentDate: '',
            timeTimer: null,
            titleTimer: null,
            currentUsername: '',
            greetingText: ''
        }
    },
    computed: {
        styleVars() {
            const o = {}
            if (this.textColor) o['--header-text-color'] = this.textColor
            if (this.padding) o['--header-padding'] = this.padding
            return o
        }
    },
    mounted() {
        // 页面加载时获取一次时间
        this.updateDateTime();
        // 获取当前用户名称
        const u = getUser();
        this.currentUsername = u?.username || '';
        // 加载站点标题
        this.fetchTitle();
        // 设置定时器每分钟更新一次时间
        this.timeTimer = setInterval(() => {
            this.updateDateTime();
        }, 60000);
        // 定时轮询站点标题（每10秒）
        this.titleTimer = setInterval(() => {
            this.fetchTitle();
        }, 10000);
    },
    beforeUnmount() {
        // 组件卸载时清除定时器
        if (this.timeTimer) {
            clearInterval(this.timeTimer);
        }
        if (this.titleTimer) {
            clearInterval(this.titleTimer);
        }
    },
    methods: {
        async fetchTitle() {
            try {
                const res = await http.get('admin/site/title/');
                const data = res.data || {};
                this.title = data.home_title || this.title;
            } catch (e) {
                // 静默失败，保留原有标题
                console.warn('获取站点标题失败', e);
            }
        },
        updateDateTime() {
            const now = new Date();

            // 获取星期几
            const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            this.currentWeekday = weekdays[now.getDay()];

            // 获取年月日，格式化为YYYY-MM-DD
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            this.currentDate = `${year}-${month}-${day}`;

            // 根据当前时间生成问候语（四段：凌晨/上午/下午/晚上）
            const hour = now.getHours();
            if (hour < 5) {
                this.greetingText = '凌晨好';
            } else if (hour < 12) {
                this.greetingText = '上午好';
            } else if (hour < 19) {
                this.greetingText = '下午好';
            } else {
                this.greetingText = '晚上好';
            }
        }
    }
}

</script>

<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* 两侧按比例留白，适配不同屏幕宽度 */
    padding: var(--header-padding, 20px 1.5%);
    background-image: url(../assets/13b710ca3033664bc662b68497795f24.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-bottom: 1px solid #ddd;
    height: 100px;
    --header-height: 100px;

}

.header>p {
    margin: 0;
    font-size: 18px;
    color: var(--header-text-color, var(--color-text-primary));
}

.right_title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 10px;

}

.right_title p {
    margin: 0;
    font-size: 14px;
    color: var(--header-text-color, var(--color-text-secondary));
    text-align: right;
}

.no-bg {
    background-image: none !important;
    background-color: var(--color-surface);
}
</style>
